import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EventService } from '../../shared/event/event.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private eventService: EventService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          // console.log(JSON.stringify(err, Object.getOwnPropertyNames(err), 4));
          if (
            !(
              err.status === 401 &&
              (err.message === '' || (err.url && err.url.includes('api/account')))
            )
          ) {
            this.eventService.broadcast('httpError', err);
          }
        },
      })
    );
  }
}
